import * as React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router';
import RouteNotFound from '@common/components/route-not-found';

import { AdminEventsContainer } from './containers/admin-events';
import { EventFormContainer } from './containers/event-form';
import { EventDetailsContainer } from './containers/event-details-container';

import './events.scss';

const EventsRouter = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={[path, `${path}/filter/:filter`]} component={AdminEventsContainer} />
      <Route path={[`${path}/create`, `${path}/edit/:id`]} component={EventFormContainer} />
      <Route path={`${path}/:eventId`} component={EventDetailsContainer} />
      <Route component={RouteNotFound} />
    </Switch>
  );
};

export default EventsRouter;
